import { useCallback, useMemo } from "react";

import { useApi } from "shared/services/api/useApi";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";

const useRetainersDashboardData = (endpointPathText) => {
    const { getDataAsync } = useApi();

    const { retainerId } = useParams();

    const getDataLayoutApiCall = useCallback(async () => {
        const response = await getDataAsync("retainersDashboardDataLayout", {
            urlParams: [
                { name: "$retainerId", value: retainerId },
                { name: "$endpointPathText", value: endpointPathText },
            ],
        });

        const result = response.status === 204
            ? null
            : response.json();

        return result;

    }, [getDataAsync, retainerId, endpointPathText]);

    const list = useQuery(`${endpointPathText}List`, getDataLayoutApiCall);

    return useMemo(() => {
        return {
            list,
        };
    }, [list]);
};

export default useRetainersDashboardData;

export const useRetainerSubJobCount = () => {
    const { getDataAsync } = useApi();

    const getRetainerSubjobCountApiCall = useCallback(
        async (retainerId) => {
            const response = await getDataAsync("getRetainerSubjobCount", {
                urlParams: [{ name: "$retainerId", value: retainerId }],
            });

            const result = response.status === 204
                ? null
                : response.json();

            return result;

        },
        [getDataAsync]
    );

    return useMemo(() => {
        const useSubjobCount = (retainerId) =>
            useQuery(["getSubJobCount", retainerId], () =>
                getRetainerSubjobCountApiCall(retainerId)
            );

        return {
            useSubjobCount,
        };
    }, [getRetainerSubjobCountApiCall]);
};
